import React, { Component } from 'react';

class LoadingScreen extends Component {
  render() {
    return (
      <div className="loading-screen">
        <h1>Loading...</h1>
      </div>
    )
  }
}

export default LoadingScreen
